import { AfterViewInit, Component, input, OnDestroy, output } from '@angular/core';

import { NotificationBannerComponent } from '@app/shared/components/notification-banner/notification-banner.component';
import { SystemNotificationMessage } from './system-notification-message.model';

@Component({
  selector: 'topo-system-notification-banner',
  imports: [NotificationBannerComponent],
  template: `
    @let n = notification();
    <div
      [id]="n.uId"
      class="system-notification-banner"
      (mouseenter)="clearTimeout()"
      (mouseleave)="initTimeout()">
      <topo-notification-banner
        [type]="n.type"
        showTypeIcon
        closeable
        (onClose)="onCloseClicked(n.uId)">
        <div [innerHtml]="n.message"></div>
      </topo-notification-banner>
    </div>
  `
})
export class SystemNotificationBannerComponent implements AfterViewInit, OnDestroy {
  onClose = output<string>(); // emit uId of message on close for parent to handle removal
  notification = input.required<SystemNotificationMessage>();

  private timeoutFn: NodeJS.Timeout;

  ngAfterViewInit(): void {
    this.initTimeout();
  }

  ngOnDestroy(): void {
    this.clearTimeout();
  }

  initTimeout(): void {
    const { uId, timeout: timeoutInMs = 0 } = this.notification();

    if (timeoutInMs > 0) {
      this.timeoutFn = setTimeout(() => {
        this.onClose.emit(uId);
      }, timeoutInMs);
    }
  }

  clearTimeout(): void {
    if (!!this.timeoutFn) {
      clearTimeout(this.timeoutFn);
      this.timeoutFn = null;
    }
  }

  onCloseClicked(uId: string): void {
    this.clearTimeout();
    this.onClose.emit(uId);
  }
}
